import './index.css';

import * as React from 'react';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import Constants from 'src/common/Constants';
import Group from 'src/entities/Group';
import Member from 'src/entities/Member';
import Wiki from 'src/entities/Wiki';

import { readWikisByGroup } from '../../actions/wiki';
import PlusWhite from '../../res/img/plus_white.svg';
import Navigation from '../Navigation/global';
import NavigationMember from '../Navigation/member';
import SwitchAdmin from '../Navigation/switchAdmin';

interface IProps {
  account: Member;
  group: Group;
  wikis: Wiki[];
  readWikisByGroup: (group: Group) => void;
}

interface IState {
  loadedApis: number[];
}

class WikiComponent extends React.Component<IProps, IState> {
  constructor(props: any) {
    super(props);
    this.state = {
      loadedApis: []
    };
  }

  componentWillMount() {
    if (
      this.props.group !== undefined &&
      !this.state.loadedApis.includes(this.props.group.id)
    ) {
      this.setState({
        loadedApis: [...this.state.loadedApis, this.props.group.id]
      });
      this.props.readWikisByGroup(this.props.group);
    }
  }

  componentDidUpdate() {
    if (
      this.props.group !== undefined &&
      !this.state.loadedApis.includes(this.props.group.id)
    ) {
      this.setState({
        loadedApis: [...this.state.loadedApis, this.props.group.id]
      });
      this.props.readWikisByGroup(this.props.group);
    }
  }

  render() {
    if (this.props.group === undefined) {
      return null;
    }

    if (!this.props.group.functions.includes(Constants.FUNCTION_WIKI)) {
      return (
        <div id="WikiIndex">
          {this.renderHeader()}
          <div id="FunctionNotFound">
            ウィキ機能は本グループで無効になっています。
          </div>
        </div>
      );
    }

    return (
      <div id="WikiIndex">
        {this.renderHeader()}
        <div id="Wikis">
          {this.props.wikis.length ? (
            <div>
              {this.props.wikis.map(wiki => (
                <Link
                  key={wiki.id}
                  to={'/' + this.props.group.title + '/wiki/' + wiki.id}
                >
                  <div className="WikiItem">{wiki.title}</div>
                </Link>
              ))}
            </div>
          ) : (
            <div id="NoWiki">ウィキがありません</div>
          )}
        </div>

        {this.props.group.admins.includes(this.props.account.id) ? (
          <Link to={'/' + this.props.group.title + '/wikis/create'}>
            <div id="TriggerNewWiki">
              <img src={PlusWhite} />
            </div>
          </Link>
        ) : null}
      </div>
    );
  }

  renderHeader() {
    return (
      <div>
        <Navigation group={this.props.group.title} />

        <div id="NavigationFunction">
          <NavigationMember function="wiki" group={this.props.group} />

          {this.props.account.isSystemAdmin ||
          this.props.group.admins.includes(this.props.account.id) ? (
            <SwitchAdmin group={this.props.group} />
          ) : null}
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state: any, ownProps: any) => ({
  group: state.Group.find(
    (group: Group) => group.title === ownProps.match.params.group
  ),
  account: state.Account,
  wikis: state.Wiki.filter(
    (wiki: Wiki) =>
      wiki.groupId ===
      state.Group.find(
        (group: Group) => group.title === ownProps.match.params.group
      ).id
  ),
  t: Date.now()
});

const mapDispatchToProps = (dispatch: any) => {
  return {
    readWikisByGroup(group: Group) {
      dispatch(readWikisByGroup(group));
    }
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(WikiComponent);



// WEBPACK FOOTER //
// ./src/components/Wiki/index.tsx